import { jsxs, jsx } from 'react/jsx-runtime';

const SvgFormAddSquareOutlined = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M11 17h2v-4h4v-2h-4V7h-2v4H7v2h4v4Z" }), jsx("path", { fill: "#2D2E2E", d: "M3 3v18h18V3H3Zm16 16H5V5h14v14Z" })] }));

export { SvgFormAddSquareOutlined as default };
//# sourceMappingURL=FormAddSquareOutlined.es.js.map
